module.exports = require("chroma-js");